export { default } from './JoinAccount'



// WEBPACK FOOTER //
// ./src/pages/JoinAccount/index.js